import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionPage_OneMission_QueryDocument = graphql(`
  query MissionPage_OneMission_Query($id: Id!) {
    findOneMission(id: $id) {
      _id
      code
      compositeMissionId
      folderId
      kind
      typeId
      workflowId

      consolidation {
        title
        ...FolderBusinessEntity_FolderBusinessEntityConsolidation_Fragment
        ...UiSettingsContext_QuotationEmitters_Fragment
      }

      reportInfos {
        ...MissionReportPage_ReportInfo_Fragment
      }

      quotationInfo {
        ...MissionQuotationPage_QuotationInfo_Fragment
      }

      accountingInfo {
        ...MissionAccountingPage_AccountingInfo_Fragment
      }

      ...MissionPage_Tabs_Mission_Fragment
      ...MissionArchiveInfoDialog_Mission_Fragment
      ...QuotationProofFileFields_Mission_Fragment
      ...NavigationContext_MissionSpaceInfo_Mission_Fragment
      ...DocumentEditorResolvers_QuickAccess_Mission_Fragment
    }
  }
`);

export type MissionPage_OneMission = ResultOf<
  typeof MissionPage_OneMission_QueryDocument
>['findOneMission'];

export const useFindOneMissionQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    MissionPage_OneMission_QueryDocument,
    { id },
    { enabled: !!id },
  );
